<template>
  <div>
    <div class="top-ds">
      <div v-if="lang === 'zh'" class="lotljsl-jhljsl"
        :class="clickIndex === 1 ? 'active textColor1' : 'unactive textColor2'" @click="clickItem(1)">
        <div class="iotljsl">
          <div>{{ $t('home.name11') }}</div>
          <div class="ljsl-xzsl"><span class="ljsl">{{ topData.iotNum }}</span><span class="byxz">{{ $t('home.name12')
              }}</span><span class="byxzsl">{{ topData.iotMonthNum }}</span></div>
        </div>
        <div class="line"></div>
        <div class="iotljsl">
          <div>{{ $t('home.name13') }}</div>
          <div class="ljsl-xzsl"><span class="ljsl">{{ topData.activeIotNum }}</span><span class="byxz">{{
            $t('home.name12') }}</span><span class="byxzsl">{{ topData.activeIotMonthNum }}</span></div>
        </div>
      </div>
      <div v-else class="lotljsl-jhljsls" :class="clickIndex === 1 ? 'active textColor1' : 'unactive textColor2'"
        @click="clickItem(1)">
        <div class="iotljsl">
          <div>{{ $t('home.name11') }}</div>
          <div class="ljsl-xzsl"><span class="ljsl">{{ topData.iotNum }}</span><span class="byxz">{{ $t('home.name12')
              }}</span><span class="byxzsl">{{ topData.iotMonthNum }}</span></div>
        </div>
        <div class="line"></div>
        <div class="iotljsl">
          <div>{{ $t('home.name13') }}</div>
          <div class="ljsl-xzsl"><span class="ljsl">{{ topData.activeIotNum }}</span><span class="byxz">{{
            $t('home.name12') }}</span><span class="byxzsl">{{ topData.activeIotMonthNum }}</span></div>
        </div>
      </div>
      <div :class="lang === 'zh' ? 'item-data' : 'item-datas'">
        <div class="item-ljsl" :class="clickIndex === 2 ? 'active textColor1' : 'unactive textColor2'"
          @click="clickItem(2)">
          <div>{{ $t('home.name14') }}</div>
          <div class="ljsl-xzsl"><span class="ljsl" :class="clickIndex === 2 ? 'textColor1' : 'textColor3'">{{
            topData.faultNum }}</span><span class="byxz">{{ $t('home.name12') }}</span><span class="byxzsl">{{
                topData.faultMonthNum }}</span></div>
        </div>
        <div class="item-ljsl" :class="clickIndex === 3 ? 'active textColor1' : 'unactive textColor2'"
          @click="clickItem(3)">
          <div>{{ $t('home.name15') }}</div>
          <div class="ljsl-xzsl"><span class="ljsl" :class="clickIndex === 3 ? 'textColor1' : 'textColor3'">{{
            topData.simTrafficNum }}</span><span class="byxz">{{ $t('home.name12') }}</span><span class="byxzsl">{{
                topData.simTrafficMonthNum }}</span></div>
        </div>
        <div class="item-ljsl" :class="clickIndex === 4 ? 'active textColor1' : 'unactive textColor2'"
          @click="clickItem(4)" v-if="userinfo.tenantType !== 20 && userinfo.tenantType !== 1">
          <div>{{ $t('home.name16') }}</div>
          <div class="ljsl-xzsl"><span class="ljsl" :class="clickIndex === 4 ? 'textColor1' : 'textColor3'">{{
            topData.manufacturerNum }}</span><span class="byxz">{{ $t('home.name12') }}</span><span class="byxzsl">{{
                topData.manufacturerMonthNum }}</span></div>
        </div>
        <!-- <div class="item-ljsl" :class="clickIndex === 5 ? 'active textColor1' : 'unactive textColor2'" @click="clickItem(5)" v-if="userinfo.tenantType !== 20">
            <div>{{ $t('home.name17') }}</div>
            <div class="ljsl-xzsl"><span class="ljsl" :class="clickIndex === 5 ? 'textColor1' : 'textColor3'">{{ topData.merchantNum }}</span><span class="byxz">{{ $t('home.name12') }}</span><span class="byxzsl">{{ topData.merchantMonthNum }}</span></div>
          </div> -->
      </div>
    </div>
    <div class="title-query">
      <div class="title">
        {{ title }}
      </div>
      <div class="query">
        <el-cascader
          v-show="(userinfo.tenantType === 0 || userinfo.tenantType === 1) && clickIndex !== 4 && clickIndex !== 5"
          ref="refHandle" :placeholder="$t('home.name21')" @change="handleChange" :show-all-levels="false"
          :props="{ lazy: true, lazyLoad: loadOptions, checkStrictly: true }" clearable></el-cascader>
        <el-select v-show="clickIndex === 5" v-model="tenantId1" :placeholder="$t('operate.name4')"
          @change="handleChange1" clearable>
          <el-option v-for="item in manufacturerOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <!-- <el-cascader v-if="clickIndex === 5"  ref="refHandle1" :placeholder="$t('operate.name4')"  @change="handleChange1" :show-all-levels="false" :props="{ lazy: true, lazyLoad: loadOptions1, checkStrictly: true }" clearable></el-cascader> -->
        <!-- <el-select class="select-width margin-left10" v-model="merchantType" placeholder="商户类型" @change="changeType" v-if="userinfo.tenantType !== 20">
            <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select> -->
        <el-date-picker class="margin-left10" v-model="monthValue" type="monthrange" :editable="false"
          :clearable="false" format="yyyy-MM" value-format="yyyy-MM" :range-separator="$t('public.name9')"
          :start-placeholder="$t('public.name15')" :end-placeholder="$t('public.name16')"
          :picker-options="monthpickoption" @change="changeMonthValue">
        </el-date-picker>
      </div>
    </div>
    <div class="content-view">
      <div class="line-charts" v-if="clickIndex === 1">
        <div class="multiple-line1">
          <MultipleLine ref="LineTwoChart1" chartid="LineTwoChart1" id="LineTwoChart1" />
        </div>
        <RLMapCompents :tenant-id="tenantIds" :start-time="startTime" :end-time="endTime"></RLMapCompents>
        <div class="csb-top" v-if="userinfo.tenantType !== 20">
          <!-- <div class="icon-title"> <img class="icon" src="@/assets/Frame1126.png" />
              <div class="title" v-if="userinfo.tenantType === 1">{{ $t('home.name22') }}</div>
              <div class="title" v-else>{{ $t('home.name20') }}</div>
            </div> -->
          <!-- <div class="content-title"> -->
          <!-- <div class="row1"></div> -->
          <!-- <div class="row2" v-if="userinfo.tenantType === 1">商户名称</div> -->
          <!-- <div class="row2" v-else>厂商名称</div>
              <div class="row3">使用量</div> -->
          <!-- </div> -->
          <div class="content-content" v-for="(item, index) in lLPaiMing" :key="index">
            <div class="row1" v-if="index < 3"><span :class="['num1', 'num2', 'num3'][index]">{{ index + 1 }}</span></div>
            <div class="row1" v-else><span class="num">{{ index + 1 }}</span></div>
            <div class="row2">{{ item.name }}</div>
            <div class="row3">{{ item.value }}</div>
          </div>
        </div>
      </div>
      <div class="line-charts" v-if="clickIndex === 2">
        <div class="multiple-line1">
          <MultipleLine2 ref="LineTwoChart2" chartid="LineTwoChart2" @updateSelect="updateSelect" id="LineTwoChart2" />
        </div>
        <div class="pie-chart">
          <PieChart ref="PieChart" chartid="PieChart" />
        </div>
      </div>
      <div class="line-charts" v-if="clickIndex === 3">
        <div class="multiple-line">
          <MultipleLine ref="LineTwoChart3" chartid="LineTwoChart3" id="LineTwoChart3" />
        </div>
        <!-- <div class="cs-top"  v-if="userinfo.tenantType !== 20"> -->
        <!-- <div class="icon-title"> <img class="icon" src="@/assets/Frame1126.png" /><div class="title">使用量TOP5</div></div> -->
        <!-- <div class="content-title">
              <div class="row1">使用量排名</div>
              <div class="row2">厂商名称</div>
              <div class="row3">使用量</div>
            </div> -->
        <!-- <div class="content-content" v-for="(item, index) in lLPaiMing1" :key="index">
              <div v-if="index < 3">
                <div class="row1" v-if="index ===0">
                <img class="icon" src="@/assets/1.png" />
              </div>
              <div class="row1" v-if="index ===1">
                <img class="icon" src="@/assets/2.png" />
              </div>
              <div class="row1" v-if="index ===2">
                <img class="icon" src="@/assets/3.png" />
              </div>
              </div>
              <div class="row1" v-else><span class="num">{{ index + 1 }}</span></div>
              <div class="row2">{{ item.name }}</div>
              <div class="row3">{{ item.value }}</div>
            </div> -->
        <!-- </div> -->
      </div>
      <div class="line-charts" v-if="clickIndex === 4">
        <div class="multiple-line">
          <MultipleLine ref="LineTwoChart4" chartid="LineTwoChart4" id="LineTwoChart4" />
        </div>
      </div>
      <div class="line-charts" v-if="clickIndex === 5">
        <div class="multiple-line">
          <MultipleLine ref="LineTwoChart5" chartid="LineTwoChart5" id="LineTwoChart5" />
        </div>
      </div>
    </div>
  </div>
  <!-- <el-tabs v-model="activeName" class="el-tabs" v-if="userinfo.tenantType === 0">
      <el-tab-pane label="车辆" name="first"></el-tab-pane>
      <el-tab-pane label="运营" name="second"></el-tab-pane>
    </el-tabs>
     <div v-if="activeName === 'first' && userinfo.tenantType === 0">
      <First />
     </div>
     <div v-if="activeName === 'second' && userinfo.tenantType === 0">
      <Second />
     </div>
     <div v-if="userinfo.tenantType === 22">
      <Three />
     </div>
     <div v-if="userinfo.tenantType === 1 || userinfo.tenantType === 3">欢迎使用Listek物联网系统</div> -->
</template>
<script>
// import First from './components/First.vue'
// import Second from './components/Second.vue'
// import Three from '@/view/home/components/Three.vue'
import { tenantList } from '@/api/manage.js'
import {
  dataOverViewFirstLine,
  newIotDeviceTrends,
  newFaultTrends,
  findFaultTrends,
  listTenantId,
  top5Manufacturer,
  newManufacturerTrends,
  newMerchantTrends
} from '@/api/home.js'
import { mapGetters } from 'vuex'
import MultipleLine from '@/components/MultipleLine.vue'
import MultipleLine2 from '@/components/MultipleLine2.vue'
import PieChart from '@/components/PieChart.vue'
import RLMapCompents from './rlMapCompents.vue'
import { numberExchange } from '@/utils/utils.js'
export default {
  computed: {
    ...mapGetters(['userinfo'])
  },
  components: {
    MultipleLine,
    MultipleLine2,
    PieChart,
    // First,
    // Second,
    // Three,
    RLMapCompents
  },
  data () {
    return {
      topData: {
        activeIotMonthNum: 0,
        activeIotNum: 0,
        faultMonthNum: 0,
        faultNum: 0,
        iotMonthNum: 0,
        iotNum: 0,
        manufacturerMonthNum: 0,
        manufacturerNum: 0,
        merchantMonthNum: 0,
        merchantNum: 0,
        simTrafficMonthNum: 0,
        simTrafficNum: 0
      },
      clickIndex: 1,
      title: this.$t('home.name7'),
      tenantId: null,
      tenantId1: null,
      tenantIds: null,
      merchantType: '',
      typeOptions: [],
      lLPaiMing: [],
      lLPaiMing1: [
        // { name: '溧水电子厂', value: '3' }
        // { name: '恒泰实业集团', value: '251656' },
        // { name: '新日金属制品厂', value: '251656' },
        // { name: '嘉禾化工厂', value: '251656' },
        // { name: '讯飞科技有限公司', value: '251656' }
      ],
      monthValue: [],
      faultXData: [],
      minDate: null,
      maxDate: null,
      startTime: '',
      endTime: '',
      showPie: true,
      trendData: {
        date: []
      },
      lang: 'zh',
      manufacturerOptions: [],
      monthpickoption: {
        disabledDate: time => {
          if (this.minDate !== null && this.maxDate === null) {
            const minMonth = this.minDate.getMonth()
            const lastYear = new Date(this.minDate).setMonth(minMonth - 11)
            const nextYear = new Date(this.minDate).setMonth(minMonth + 11)
            const minTime = this.minDate.getTime()
            const nextTime = new Date().setMonth(new Date().getMonth() + 11)
            const lastTime = new Date().setMonth(new Date().getMonth() - 11)
            if (minTime <= nextTime || minTime >= lastTime) {
              return time.valueOf() > new Date().getTime() || time.valueOf() > nextYear.valueOf() || time.valueOf() < lastYear.valueOf()
            } else {
              return time.valueOf() < lastYear.valueOf() || time.valueOf() > nextYear.valueOf()
            }
          } else {
            const startMonth = this.trendData.date[0]
            const month = new Date(startMonth).getMonth()
            const lastMonth = new Date(startMonth).setMonth(month - 11)
            return this.monthPick(time) || time < lastMonth.valueOf()
          }
        },
        onPick: ({ minDate, maxDate }) => {
          this.minDate = minDate
          this.maxDate = maxDate
        }
      }
    }
  },
  created () {
    this.monthValue[0] = this.$moment(new Date(new Date().getFullYear(), new Date().getMonth() - 11, 1)).format('yyyy-MM')
    this.monthValue[1] = this.$moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('yyyy-MM')
    this.startTime = this.monthValue[0]
    this.endTime = this.monthValue[1]
    this.lang = localStorage.getItem('lang')
    this.$bus.$on('lang', (lang) => {
      // this.$refs.LineTwoChart1.chartResize()
      // this.$refs.LineTwoChart2.chartResize()
      // this.$refs.LineTwoChart3.chartResize()
      // this.$refs.LineTwoChart4.chartResize()
      // this.$refs.LineTwoChart5.chartResize()
      this.lang = localStorage.getItem('lang')
      this.clickItem(this.clickIndex)
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.chartResize)
    this.$bus.$off('lang')
  },
  mounted () {
    if (this.userinfo.tenantType !== 22) {
      this.getNewIotDeviceTrends()
    }
    this.getDataOverViewFirstLine()
    // this.getTop5Manufacturer()
    this.loadOptions1()
  },
  methods: {
    getDataOverViewFirstLine () {
      dataOverViewFirstLine()
        .then((res) => {
          this.topData = {
            activeIotMonthNum: numberExchange(res.data.activeIotMonthNum) || 0,
            activeIotNum: numberExchange(res.data.activeIotNum) || 0,
            faultMonthNum: numberExchange(res.data.faultMonthNum) || 0,
            faultNum: numberExchange(res.data.faultNum) || 0,
            iotMonthNum: numberExchange(res.data.iotMonthNum) || 0,
            iotNum: numberExchange(res.data.iotNum) || 0,
            manufacturerMonthNum: numberExchange(res.data.manufacturerMonthNum) || 0,
            manufacturerNum: numberExchange(res.data.manufacturerNum) || 0,
            merchantMonthNum: numberExchange(res.data.merchantMonthNum) || 0,
            merchantNum: numberExchange(res.data.merchantNum) || 0,
            simTrafficMonthNum: numberExchange(res.data.simTrafficMonthNum) || 0,
            simTrafficNum: numberExchange(res.data.simTrafficNum) || 0
          }
        })
        .catch(() => { })
    },
    getNewIotDeviceTrends () {
      const data = {
        // tenantType: '',
        tenantId: this.tenantId,
        startTime: this.monthValue[0],
        endTime: this.monthValue[1]
      }
      newIotDeviceTrends(data)
        .then((res) => {
          const xData = []
          const yData1 = []
          const yData2 = []
          res.data.map((item) => {
            xData.push(item.month)
            yData1.push(item.create_count)
            yData2.push(item.active_count)
          })
          this.$nextTick(() => {
            this.$refs.LineTwoChart1.setOptions(
              xData,
              [yData1, yData2], [this.$t('home.name18'), this.$t('home.name19')]
            )
          })
        })
        .catch(() => { })
    },
    getNewManufacturerTrends () {
      const data = {
        startTime: this.monthValue[0],
        endTime: this.monthValue[1]
      }
      newManufacturerTrends(data)
        .then((res) => {
          const xData = []
          const yData = []
          res.data.map((item) => {
            xData.push(item.month_year)
            yData.push(item.count)
          })
          this.$nextTick(() => {
            this.$refs.LineTwoChart4.setOptions(
              xData,
              [yData], ['新增数量']
            )
          })
        })
        .catch(() => { })
    },
    getNewFaultTrends () {
      const data = {
        // tenantType: '',
        tenantId: this.tenantId,
        startTime: this.monthValue[0],
        endTime: this.monthValue[1]
      }
      newFaultTrends(data)
        .then((res) => {
          const xData = []
          const yData = []
          res.data.map((item) => {
            xData.push(item.month)
            yData.push(item.create_count)
          })
          this.faultXData = xData
          this.$refs.LineTwoChart2.setOptions(
            xData, [yData], ['故障数量']
          )
          this.getFindFaultTrends(this.faultXData[this.faultXData.length - 1])
        })
        .catch(() => { })
    },
    getNewMerchantTrends () {
      const data = {
        // tenantType: '',
        tenantId: this.tenantId1,
        startTime: this.monthValue[0],
        endTime: this.monthValue[1]
      }
      newMerchantTrends(data)
        .then((res) => {
          const xData = []
          const yData = []
          res.data.map((item) => {
            xData.push(item.month_year)
            yData.push(item.count)
          })
          this.$refs.LineTwoChart5.setOptions(
            xData, [yData], ['新增数量']
          )
        })
        .catch(() => { })
    },
    getFindFaultTrends (month) {
      const data = {
        month: month,
        // tenantType: '',
        tenantId: this.tenantId
      }
      findFaultTrends(data)
        .then((res) => {
          const seriesData = []
          res.data.map((item) => {
            const obj = {
              value: item.fault_count,
              name: item.fault_name
            }
            seriesData.push(obj)
          })
          var name = month + '故障'
          this.$refs.PieChart.setOptions(
            seriesData, name
          )
        })
        .catch(() => { })
    },
    getTop5Manufacturer () {
      this.lLPaiMing = []
      top5Manufacturer()
        .then((res) => {
          for (const key1 in res.data) {
            for (const key2 in res.data[key1]) {
              const obj = { name: key2, value: res.data[key1][key2] }
              this.lLPaiMing.push(obj)
            }
          }
        })
        .catch(() => { })
    },

    updateSelect (e) {
      this.faultXData.map((item, index) => {
        if (index === e) {
          this.getFindFaultTrends(item)
        }
      })
    },
    clickItem (index) {
      this.clickIndex = index
      if (this.clickIndex === 1) {
        this.$nextTick(() => {
          this.$refs.LineTwoChart1.chartResize()
        })
        this.title = this.$t('home.name7')
        this.$nextTick(() => {
          this.$refs.LineTwoChart1.setOptions(
            ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]], [this.$t('home.name18'), this.$t('home.name19')]
          )
          this.getNewIotDeviceTrends()
        })
      } else if (this.clickIndex === 2) {
        this.$nextTick(() => {
          this.$refs.LineTwoChart2.chartResize()
        })
        this.title = '故障新增趋势'
        this.$nextTick(() => {
          this.$refs.LineTwoChart2.setOptions(
            ['1月', '2月', '3月', '4月,', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]], ['故障数量']
          )
        })
        this.getNewFaultTrends()
      } else if (this.clickIndex === 3) {
        this.$nextTick(() => {
          this.$refs.LineTwoChart3.chartResize()
        })
        this.title = '流量使用趋势'
        this.$nextTick(() => {
          this.$refs.LineTwoChart3.setOptions(
            ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月'],
            [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0]], ['激活数量']
          )
        })
      } else if (this.clickIndex === 4) {
        this.$nextTick(() => {
          this.$refs.LineTwoChart4.chartResize()
        })
        this.title = '厂商新增趋势'
        this.$nextTick(() => {
          this.$refs.LineTwoChart4.setOptions(
            ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月'],
            [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0]], ['新增数量']
          )
        })
        this.getNewManufacturerTrends()
      } else if (this.clickIndex === 5) {
        this.$nextTick(() => {
          this.$refs.LineTwoChart5.chartResize()
        })
        this.title = '商户新增趋势'
        this.$nextTick(() => {
          this.$refs.LineTwoChart5.setOptions(
            ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月'],
            [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0]], ['新增数量']
          )
        })
        this.getNewMerchantTrends()
      }
    },
    loadOptions (node, resolve) {
      if (node.level === 2) {
        resolve([])
        return
      }
      let data = null
      if (node.level === 0) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 1
        }
      }
      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }

      tenantList(data)
        .then(res => {
          if (res.data.list) {
            // const tenantId = []
            // res.data.list.map((item) => {
            //   tenantId.push(item.tenantId)
            // })
            // this.tenantId = tenantId.join(',')
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 1
            }))
            resolve(options)
          } else {
            resolve([])
          }
        })
        .catch(() => { })
    },
    loadOptions1 () {
      const data = { page: 1, limit: 500, tenantType: 1 }
      tenantList(data)
        .then(res => {
          if (res.data.list) {
            this.manufacturerOptions = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName
            }))
          }
        })
        .catch(() => { })
    },
    handleChange (value) {
      this.tenantId = value[value.length - 1]
      if (this.tenantId === undefined) {
        this.tenantId = null
        this.tenantIds = null
      }
      const panelRefs = this.$refs.refHandle.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
      if (this.tenantId !== null) {
        listTenantId({ tenantId: this.tenantId }).then((res) => {
          this.tenantId = res.data.join(',')
          this.tenantIds = res.data.join(',')
          this.clickItem(this.clickIndex)
        }).catch(() => { })
      } else {
        this.clickItem(this.clickIndex)
      }
    },
    handleChange1 (value) {
      this.tenantId1 = value
      this.clickItem(this.clickIndex)
    },
    changeType (e) { },
    changeMonthValue () {
      this.startTime = this.monthValue[0]
      this.endTime = this.monthValue[1]
    },
    monthPick (time) {
      const date = new Date()
      const year = date.getFullYear()
      let month = date.getMonth() + 1
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      const nowDate = year.toString() + month.toString()
      const timeyear = time.getFullYear()
      let timemonth = time.getMonth() + 1
      if (timemonth >= 1 && timemonth <= 9) {
        timemonth = '0' + timemonth
      }
      const elTimeData = timeyear.toString() + timemonth.toString()
      return elTimeData > nowDate
    }
  }
}
</script>

<style lang="scss">
.el-tabs__item {
  padding: 0px 10px;
  cursor: pointer;
}

.el-tabs__nav-wrap::after {
  height: 0px;
}

.el-tabs__item:hover {
  color: #0f73e6;
}

.el-tabs__item.is-active {
  color: #0f73e6;
}

.el-tabs__active-bar {
  background-color: #0f73e6;
}
</style>
<style lang="scss" scoped>
.topman {
  .content-view {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .line-charts {
      display: flex;
      flex-direction: row;
      width: 100%;
      margin-top: 16px;
      position: relative;

      .multiple-line {
        width: 100%;
        background: #F9FAFF;
        height: calc(100vh - 360px);
      }

      .multiple-line1 {
        width: 50%;
        margin-right: 8px;
        background: #F9FAFF;
        height: calc(100vh - 360px);
      }

      .csb-top {
        position: absolute;
        left: 50%;
        top: 10px;
        width: 30%;
        display: flex;
        flex-direction: column;

        .icon-title {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-top: 25px;
          margin-left: 58px;

          .icon {
            width: 32px;
            height: 32px;
          }

          .title {
            font-size: 16px;
            color: #0C2358;
            margin-left: 10px;
          }
        }

        .content-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: rgba($color: #ffffff, $alpha: 0.6);
          width: calc(100% - 40px);
          margin-left: 20px;
          margin-top: 17px;
          color: #555555;
          font-size: 16px;
          height: 55px;
        }

        .content-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: calc(100% - 40px);
          margin-top: 17px;
          margin-left: 20px;
          background: #fff;
          color: #555555;
          font-size: 16px;
          font-weight: 600;
          height: 55px;
        }

        .num1 {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 20px;
          height: 20px;
          color: #9A3D0E;
          background: #FF773480;
          border: 1px solid #FF7734
        }

        .num2 {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 20px;
          height: 20px;
          color: #866906;
          background: #FAC30080;
          border: 1px solid #FFC700;
        }

        .num3 {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 20px;
          height: 20px;
          color: #118469;
          background: #34FFCE80;
          border: 1px solid #34FFE7
        }

        .num {
          width: 20px;
          height: 20px;
          border: 1px solid #0F73E6;
          background: #0F73E61A;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .row1 {
          width: 100px;
          padding-left: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
        }

        .row2 {
          width: 150px;
          display: flex;
        }

        .row3 {
          width: 100px;
          display: flex;
        }
      }

      .cs-top {
        width: 50%;
        margin-left: 8px;
        background: #F9FAFF;
        display: flex;
        flex-direction: column;

        .icon-title {
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-top: 25px;
          margin-left: 58px;

          .icon {
            width: 32px;
            height: 32px;
          }

          .title {
            font-size: 16px;
            color: #0C2358;
            margin-left: 10px;
          }
        }

        .content-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: calc(100% - 40px);
          margin-top: 17px;
          margin-left: 20px;
          color: #555555;
          font-size: 16px;
          height: 55px;
        }

        .content-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: calc(100% - 40px);
          margin-top: 17px;
          margin-left: 20px;
          background: linear-gradient(90deg, #E0E6FF 0%, #EDF0FF 100%);
          color: #000000;
          font-size: 16px;
          font-weight: 600;
          height: 55px;
        }

        .num1 {
          width: 20px;
          height: 20px;
          color: #9A3D0E;
          background: #FF773480;
          border: 1px solid #FF7734
        }

        .num {
          width: 30px;
          height: 30px;
          border: 1px solid #dcdddd;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .row1 {
          width: 120px;
          padding-left: 30px;
          display: flex;
          align-items: center;
          justify-content: center;

          .icon {
            width: 30px;
            height: 33.69px;
          }
        }

        .row2 {
          width: 150px;
          display: flex;
        }

        .row3 {
          width: 100px;
          display: flex;
        }
      }

      .pie-chart {
        width: 50%;
        margin-left: 8px;
        background: #F9FAFF;
      }
    }
  }

  .title-query {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
  }

  .margin-left10 {
    margin-left: 10px;
  }

  .top-ds {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    width: 100%;

    .active {
      background: linear-gradient(96.32deg, #4B9FFF -18.62%, #0F73E6 97.86%);
    }

    .unactive {
      background: #F4F5FF;
    }

    .textColor1 {
      color: #fff;
    }

    .textColor2 {
      color: #555555;
    }

    .textColor3 {
      color: #0F73E6;
    }

    .item-data {
      display: flex;
      // justify-content: space-between;
      flex-direction: row;
      align-items: center;
      width: calc(100% - 400px);
      overflow: auto;

      .item-ljsl {
        width: 400px;
        height: 120px;
        margin-left: 8px;
        margin-right: 8px;
        display: flex;
        // align-items: center;
        padding-left: 12px;
        justify-content: center;
        flex-direction: column;
        border-radius: 8px;
        cursor: pointer;

        .ljsl-xzsl {
          margin-top: 10px;

          .ljsl {
            font-family: 'D-DIN-PRO-700';
            font-size: 32px;
            line-height: 42px;
          }

          .byxz {
            font-size: 12px;
            margin-left: 10px;
          }

          .byxzsl {
            font-family: 'PuHuiTi-400';
            font-size: 18px;
            font-weight: 500;
            margin-left: 4px;
          }
        }
      }
    }

    .item-datas {
      display: flex;
      // justify-content: space-between;
      flex-direction: row;
      align-items: center;
      // width: fit-content;
      width: auto;
      flex: none;

      .item-ljsl {
        width: 400px;
        height: 120px;
        margin-left: 8px;
        margin-right: 8px;
        display: flex;
        // align-items: center;
        padding-left: 12px;
        justify-content: center;
        flex-direction: column;
        border-radius: 8px;
        cursor: pointer;

        .ljsl-xzsl {
          margin-top: 10px;

          .ljsl {
            font-family: 'D-DIN-PRO-700';
            font-size: 32px;
            line-height: 42px;
          }

          .byxz {
            font-size: 12px;
            margin-left: 10px;
          }

          .byxzsl {
            font-family: 'PuHuiTi-400';
            font-size: 18px;
            font-weight: 500;
            margin-left: 4px;
          }
        }
      }
    }

    .lotljsl-jhljsl {
      width: 400px;
      height: 120px;
      border-radius: 8px;
      margin-right: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;

      .iotljsl {
        width: 48%;
        display: flex;
        flex-direction: column;
        font-size: 16px;
        padding-left: 12px;

        .ljsl-xzsl {
          margin-top: 10px;

          .ljsl {
            font-family: 'D-DIN-PRO-700';
            font-size: 32px;
            line-height: 42px;
          }

          .byxz {
            font-size: 12px;
            margin-left: 10px;
          }

          .byxzsl {
            font-family: 'PuHuiTi-400';
            font-size: 18px;
            font-weight: 500;
            margin-left: 4px;
          }
        }
      }

      .line {
        width: 1px;
        height: 46px;
        background: rgba($color: #ffffff, $alpha: 0.8);
      }
    }

    .lotljsl-jhljsls {
      width: 635px;
      height: 120px;
      border-radius: 8px;
      margin-right: 8px;
      display: flex;
      flex: none;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;

      .iotljsl {
        width: 48%;
        display: flex;
        flex-direction: column;
        font-size: 16px;
        padding-left: 12px;

        .ljsl-xzsl {
          margin-top: 10px;

          .ljsl {
            font-family: 'D-DIN-PRO-700';
            font-size: 32px;
            line-height: 42px;
          }

          .byxz {
            font-size: 12px;
            margin-left: 10px;
          }

          .byxzsl {
            font-family: 'PuHuiTi-400';
            font-size: 18px;
            font-weight: 500;
            margin-left: 4px;
          }
        }
      }

      .line {
        width: 1px;
        height: 46px;
        background: rgba($color: #ffffff, $alpha: 0.8);
      }
    }
  }

  .el-tabs {
    position: fixed;
    right: 30px;
    top: 70px;
    z-index: 1999;
  }

  .top-layout {
    display: flex;
    justify-content: space-between;
    // flex-direction: row;
    align-items: center;
    min-width: 1200px;

    .zw {
      width: 1.11vw;
      min-width: 20px;
    }

    .item-layout {
      width: px2vw(320.5);
      height: px2vw(153);
      min-width: 260.5px;
      min-height: 153px;
      border-radius: px2vw(8);
      background: #f5f5f5;
      border: 1px solid #969797;

      .hs {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        margin-left: px2vw(22);

        > :first-child {
          font-family: PuHuiTi-700;
          font-size: 48px;
          line-height: 65.86px;
          text-align: left;
          color: #555555;
        }

        > :last-child {
          font-family: PingFang SC;
          font-size: 14px;
          font-weight: 400;
          line-height: 19.6px;
          margin-left: px2vw(8);
          color: #555555;
        }
      }

      .item-content {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: px2vw(20);

        .left {
          display: flex;
          flex-direction: row;
          align-items: center;

          img {
            width: 24px;
            height: 24px;
          }

          .img2 {
            width: 16px;
            height: 16px;
          }

          div {
            font-family: PingFang SC;
            font-size: 14px;
            font-weight: 400;
            line-height: 14px;
            color: #555555;
            margin-left: px2vw(8);
          }
        }

        .right {
          display: flex;
          flex-direction: row;
          align-items: center;
          cursor: pointer;

          img {
            width: 16px;
            height: 16px;
            margin-left: px2vw(4);
          }

          div {
            font-family: PingFang SC;
            font-size: 14px;
            font-weight: 400;
            line-height: 14px;
            color: #8d96a9;
          }
        }
      }
    }
  }

  .gzqk-gzclqk {
    display: flex;
    flex-direction: row;
    background: #f5f5f5;
    width: 100%;
    height: px2vw(360);
    min-width: 1200px;
    min-height: 360px;
    border-radius: px2vw(8);
    border: 1px;
    margin-top: px2vw(20);

    .lines {
      width: 1px;
      background: #e5e3ec;
      height: px2vw(360);
      min-height: 360px;
      min-width: 1px;
    }

    .gzqk {
      width: 50%;
      position: relative;
    }

    .gzclqk {
      width: 50%;
      position: relative;
    }
  }

  .xzqs {
    display: flex;
    background: #f5f5f5;
    width: 100%;
    min-width: 1200px;
    min-height: 360px;
    height: px2vw(360);
    border-radius: px2vw(8);
    border: 1px;
    margin-top: px2vw(20);
    position: relative;
    z-index: 9;
  }

  .simksyqk {
    display: flex;
    background: #f5f5f5;
    width: 100%;
    height: px2vw(360);
    min-width: 1200px;
    min-height: 360px;
    border-radius: px2vw(8);
    border: 1px;
    margin-top: px2vw(20);
    position: relative;
    z-index: 9;
  }

  .text-select {
    display: flex;
    position: absolute;
    left: 0;
    top: 22px;
    justify-content: space-between;
    align-items: center;
    z-index: 10;
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;

    .text {
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: 500;
      line-height: 22.4px;
      color: #0c2358;
    }
  }

  .margin-left10 {
    margin-left: 10px;
  }

  .select-width {
    width: 160px;
  }

  .echarts-div {
    width: 100%;
    height: 100%;
  }

  *,
  :after,
  :before {
    box-sizing: border-box;
  }
}
</style>
